import { useState } from "react";
import { createSelectorConfirm } from "../../utils/editorHelpers";

// The selector dialogs of the header: kendaraan and trailer.
const useEditorSelectorDialogs = ({ headerData, setHeaderData }) => {
  // dialog state
  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);
  const [showTrailerSelector, setShowTrailerSelector] = useState(false);

  const handleOnClickKendaraan = () => {
    setShowKendaraanSelector(true);
  };

  const handleOnClickTrailer = () => {
    setShowTrailerSelector(true);
  };

  const handleOnConfirmKendaraan = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_kendaraan",
    idField: "kendaraan_id",
    setShow: setShowKendaraanSelector,
  });

  const handleOnConfirmTrailer = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_trailer",
    idField: "trailer_id",
    setShow: setShowTrailerSelector,
  });

  return {
    showKendaraanSelector,
    setShowKendaraanSelector,
    showTrailerSelector,
    setShowTrailerSelector,
    handleOnClickKendaraan,
    handleOnClickTrailer,
    handleOnConfirmKendaraan,
    handleOnConfirmTrailer,
  };
};

export default useEditorSelectorDialogs;
